import { array } from './arrays.mjs'
import { boolean as _boolean } from './booleans.mjs'
import { dict } from './objects.mjs'
import { either } from './unions.mjs'
import { lazy } from './utilities.mjs'
import { null_ } from './basics.mjs'
import { number } from './numbers.mjs'
import { string } from './strings.mjs'

export var jsonObject = lazy(function () {
  return dict(json)
})

export var jsonArray = lazy(function () {
  return array(json)
})

export var json = either(null_, string, number, _boolean, jsonObject, jsonArray).describe('Must be valid JSON value')
